import * as React from 'react'
import { InviewProps } from '../blocksState'
import { LogoSliderItem } from './logoSliderState'
import { Image } from '../../../../utils/images'
import LogoMarquee from './logoMarquee'
import { useInView } from '../../../../utils/hooks/hooks/useInView'

export type LogoSliderProps = {
  index: number
  inview?: InviewProps
  items: LogoSliderItem[]
}

export function LogoSliderLayout(props: LogoSliderProps) {
  const { index, inview } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LogoSliderLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={`block block--logos ${inView ? 'inview' : ''}`}>
      <div className="block__inner container--m spacing--m gutter--m">
        <div className="block__content marquee">
          <LogoMarquee as="ul" className="marquee__list" itemSelector="marquee__item">
            {props.items.map((item, key) => (
              <>
                {item.image && (
                  <li className="marquee__item" key={`ml-${key}`}>
                    <Image
                      {...item.image}
                      classNames={{
                        image: 'marquee__image'
                      }}
                    />
                  </li>
                )}
              </>
            ))}
          </LogoMarquee>
        </div>
      </div>
    </section>
  )
}
